// src/components/common/AppLoadingScreen/AppLoadingScreen.jsx
import React from 'react';
import './app-loading-screen.css';

// Shared boot/loading shell: the graphic + title + subtitle stay fixed on
// screen; only the status row underneath ever changes. This is the same
// artwork as the native launch screen (Loading.svg is the full-bleed
// export of this same graphic, used for Splash.imageset), and the same
// shell LoginScreen already used for its own post-auth "Loading your
// dashboard…" state — so reusing it here means there's no visual seam
// between the native splash, app init (App.jsx), the auth check
// (ProtectedRoute), and LoginScreen: it reads as one continuous screen
// from launch until sign-in or the dashboard is ready.
//
// `status` is the text shown under the spinner. `children`, when passed,
// replaces the default spinner+status row entirely — LoginScreen uses
// this to show its sign-in buttons in that same slot once boot is done.
export const AppLoadingScreen = ({ status = null, children = null }) => {
  return (
    <div className="app-loading-screen">
      <img
        className="app-loading-graphic"
        src="/svgs/login-logo-graphic.svg"
        alt="Range Dojo"
      />

      <div className="app-loading-text-block">
        <div className="app-loading-title">
          <span className="app-loading-title-range">Range</span>
          <span className="app-loading-title-dojo">Dojo</span>
        </div>
        <p className="app-loading-subtitle">A Solver Based Study Tool</p>
      </div>

      {children ?? (
        <div className="app-loading-status-section">
          <div className="app-loading-status-spinner" aria-hidden="true" />
          {status && <span className="app-loading-status-text">{status}</span>}
        </div>
      )}
    </div>
  );
};

export default AppLoadingScreen;
